var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"has-text-centered pt-2"},[_c('img',{staticClass:"is-inline-block",attrs:{"src":("/img/header-secure-" + _vm.locale + ".png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }